// Determinate circular progress ring drawn around the top-bar Queue icon while
// a round's downloads are in flight (iPad). Fills clockwise from 12 o'clock as
// the byte-weighted percent climbs, with a faint full-circle track showing the
// remainder. There's no shared circular-progress atom in the app, so this draws
// the two arcs directly with stroke-dasharray. Sits in the same absolute overlay
// slot as the icon's ping ring — behind the glyph, non-interactive.
//
// `currentColor` (set to the primary token on the <svg>) drives both arcs so the
// ring can't depend on a `stroke-primary` utility existing.
export function QueueDownloadRing({ percent }: { percent: number }) {
  const clamped = Math.max(0, Math.min(100, percent));
  const radius = 16;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference * (1 - clamped / 100);

  return (
    <svg
      aria-hidden
      viewBox="0 0 36 36"
      className="pointer-events-none absolute inset-0 h-full w-full -rotate-90 text-primary"
    >
      <circle
        cx="18"
        cy="18"
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeOpacity={0.2}
        strokeWidth={2}
      />
      <circle
        cx="18"
        cy="18"
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={dashOffset}
        // Ease between successive percent values so the arc glides rather than
        // stepping; reduced motion snaps straight to the new value.
        className="transition-[stroke-dashoffset] duration-300 ease-out motion-reduce:transition-none"
      />
    </svg>
  );
}
